function game_300()
{

}

game_300.odd_map  = {
  "8":[0,0,20,100,500],
  "7":[0,0,15,50,200],
  "6":[0,0,15,25,150],
  "5":[0,0,15,20,100],
  "4":[0,0,10,15,50],
  "3":[0,0,5,8,10],
  "2":[0,0,5,8,10],
  "1":[0,0,5,8,10],
};

export {
  game_300
};



// WEBPACK FOOTER //
// ./src/components/slots/game_300.js